import Base from '@hud/web-components/Container/TableContainer';

import styled from 'styled-components';

export const TableContainer = styled(Base.Container)`
  background: none;
  .channel {
    display: flex;
    align-items: center;
    gap: var(--space-75);

    &.missing {
      color: var(--text-standard-primary);
      &:hover {
        cursor: pointer;
        span {
          text-decoration: underline;
        }
      }
    }

    &.connected {
      color: var(--turquoise-400);
    }

    &.warning {
      color: var(--orange-200);
    }
  }

  ${Base.Header} {
    justify-content: space-between;
  }
`;
